import React, { useState } from 'react'
import { Box, Modal, TextHeading } from '@ally/metronome-ui'
import { useCustomizeDashboard } from '../../customizationContext/CustomizeDashboardContext'
import CustomizeTabs from './CustomizeTabs'
import CustomizeModalTrigger from './CustomizeModalTrigger'

interface ComponentProps {
  lob?: string
  triggerIsIcon?: boolean
}

const CustomizeModalContent: React.FC<{
  defaultTab: number
}> = ({ defaultTab }) => {
  const headingRef = React.createRef<HTMLHeadingElement>()
  return (
    // Padding can be removed with v23
    <Box p="sm">
      <TextHeading tag="h1" tabIndex={-1} size="md">
        Customize
      </TextHeading>
      <CustomizeTabs headingRef={headingRef} defaultTab={defaultTab} />
    </Box>
  )
}

const CustomizeModal: React.FC<ComponentProps> = ({
  lob,
  triggerIsIcon = false,
}): React.ReactElement => {
  const [defaultTab, setDefaultTab] = useState<number>(0)
  const [{ isCustomizeModalOpen }, dispatch] = useCustomizeDashboard()

  return (
    <Modal
      width="md"
      trigger={
        <CustomizeModalTrigger lob={lob} triggerIsIcon={triggerIsIcon} />
      }
      content={<CustomizeModalContent defaultTab={defaultTab} />}
      open={isCustomizeModalOpen}
      onOpenChange={(isOpening: boolean): void => {
        dispatch({ type: 'set isCustomizeModalOpen', payload: false })
        // if the remote command is used we want to reset the default tab to 0
        setDefaultTab(0)
      }}
    />
  )
}

export default CustomizeModal
